//======================================
//# TruFinance funciók jogosultsága
//======================================
import http, { handleApiResponse, handleApiResponseWithSuccess } from "@/services/http";
import ApiResponse from "@/models/ApiResponse";
import GlobalStore from "./GlobalStore";

interface PermissionCheckOptions {
  feature: string;
  modul?: string | null;
  contType?: number | null;
  featureGroup?: string | null;
}

export async function loadFeaturePermissions() {
  if (GlobalStore.userFeaturePermissions.length == 0) {
    GlobalStore.userFeaturePermissions = await http
    .get<ApiResponse<FeaturePermission[]>>(`authorization/feature`)
    .then(handleApiResponse);
  }
}

export interface FeaturePermission {
  // Melyik modul? (hlgencontdict.winname)
  modul: string;
  // Modulon belül milyen csoport? (hlgencontdict.contname)
  featureGroup: string;
  // Funkció (hlgencontdict.itemname)
  feature: string;
  // Funkció leírása (hlgencontdict.national)
  description: string | null;
  // Kontroll típusa (hlgencontdict.conttype)
  contType: number;
  // Kontroll típus megnevezése (cssysconttype.cont_name)
  contTypeDesc: string;
  // Jogosult a felahsználó?
  isGranted: boolean;

  //# Használat példa:
  //# UserFeaturePermission.checkFeaturePermission({modul: "CASHFLOWRIPORT", feature: "OVERRIDEOPENAMOUNT"})
  //# Ha a feature egyedien van elnevezve elég az is, de az kötelező. A többi csak szűrő.
  checkFeaturePermission: ({ feature, modul, contType, featureGroup }: PermissionCheckOptions) => boolean;

  //# Használat példa:
  //# UserFeaturePermission.genFeaturePermObj("CASHFLOWRIPORT");
  //# Ez legenerál egy objektumot, ahol a property nevek a feature nevek db-ből.
  //# Példa output: {OVERRIDEOPENAMOUNT: false, EDITCASHFLOW: true}
  genFeaturePermObj: (modul: string, contType?: number | null, featureGroup?: string | null) => Record<string, boolean>;
}

const UserFeaturePermission: FeaturePermission = {
  modul: "",
  featureGroup: "",
  feature: "",
  description: null,
  contType: 1,
  contTypeDesc: "",
  isGranted: false,

  checkFeaturePermission({ feature, modul, contType, featureGroup }: PermissionCheckOptions): boolean {
    loadFeaturePermissions();
    return GlobalStore.userFeaturePermissions.find(p => 
      p.feature == feature.toUpperCase() &&
      (modul == null || p.modul == modul.toUpperCase()) &&
      (contType == null || p.contType == contType) && 
      (featureGroup == null || p.featureGroup == featureGroup.toUpperCase())
    )?.isGranted ?? false;
  },

  genFeaturePermObj(modul: string, contType?: number | null, featureGroup?: string | null): Record<string, boolean> {
    const permissions: Record<string, boolean> = {};
    if (GlobalStore.userFeaturePermissions.length === 0) return permissions;

    const modulFilter = modul.toUpperCase();
    const featureGroupFilter = featureGroup?.toUpperCase();
    GlobalStore.userFeaturePermissions.forEach(p => {
      if (
        p.modul == modulFilter &&
        (contType == null || p.contType == contType) &&
        (featureGroup == null || p.featureGroup == featureGroupFilter)
      ) {
        const feature = p.feature.toUpperCase();
        permissions[feature] = p.isGranted;
      }
    });
  
    return permissions;
  }
}

export default UserFeaturePermission;